import { t } from '@lingui/macro';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import TextField from '@material-ui/core/TextField';
import classnames from 'classnames';
import React, { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import {
    onChangeCompetitorsFleetTransfersDateMode,
    onChangeCompetitorsFleetTransfersOperatorsFilter,
    onChangeCompetitorsFleetTransfersSelectedDate,
    onChangeCompetitorsFleetTransfersShowBicycles,
    onChangeCompetitorsFleetTransfersShowScooters,
} from '../../../ac/onChangeMapFilters';
import { functionalAreasYandexUrentTypes } from '../../../constants/variables';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { DynamicAttributeFilter } from '../DynamicAttributeFilter';
import { StandardRadioGroup } from '../StandardRadioGroup';
import styles from '../FilterSidebar.module.css';

const formatDate = dateStr => {
    if (!dateStr) return dateStr;
    try {
        const parts = dateStr.split('-');
        return `${parts[2]}.${parts[1]}.${parts[0]}`;
    } catch (e) {
        return dateStr;
    }
};
const FleetTransfersFilterComponent = ({
    mapFilters,
    onChangeCompetitorsFleetTransfersDateMode,
    onChangeCompetitorsFleetTransfersOperatorsFilter,
    onChangeCompetitorsFleetTransfersSelectedDate,
    onChangeCompetitorsFleetTransfersShowScooters,
    onChangeCompetitorsFleetTransfersShowBicycles,
}) => {
    const vehicleTypes = [
        { value: 'scooters', label: t`Самокаты`, stateKey: 'competitorsFleetTransfersShowScooters' },
        { value: 'bicycles', label: t`Велосипеды`, stateKey: 'competitorsFleetTransfersShowBicycles' },
    ];
    const onToggleVehicle = value => {
        if (value === 'scooters') onChangeCompetitorsFleetTransfersShowScooters();
        else onChangeCompetitorsFleetTransfersShowBicycles();
    };
    const {
        competitorsFleetTransfersDateMode: dateMode,
        competitorsFleetTransfersSelectedDate: selectedDate,
        competitorsFleetTransfersAvailableDates: availableDates,
    } = mapFilters;

    // CSS для тёмной темы селектора дат (аналог DateSelector в StartsByHourFilter)
    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `
            .fleet-transfers-date-select .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
                border-color: rgba(255, 255, 255, 0.3) !important;
            }
            .fleet-transfers-date-select .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
                border-color: rgba(255, 255, 255, 0.3) !important;
            }
            .fleet-transfers-date-select .MuiNativeSelect-select {
                color: white !important;
            }
            .fleet-transfers-date-select select {
                color: white !important;
            }
            .fleet-transfers-date-select .MuiNativeSelect-icon {
                color: rgba(255, 255, 255, 0.3) !important;
            }
            .fleet-transfers-date-select .MuiOutlinedInput-root {
                border-radius: 6px;
            }
        `;
        document.head.appendChild(style);
        return () => document.head.removeChild(style);
    }, []);

    // Автовыбор последней доступной даты когда даты загрузились в режиме выбора даты
    useEffect(() => {
        if (dateMode && !selectedDate && availableDates.length > 0) {
            onChangeCompetitorsFleetTransfersSelectedDate(availableDates[availableDates.length - 1]);
        }
    }, [ dateMode, availableDates.length ]); // eslint-disable-line react-hooks/exhaustive-deps

    const onChangePeriod = ({ target: { value } }) => {
        const isDate = value === 'date';
        onChangeCompetitorsFleetTransfersDateMode(isDate);
        if (!isDate) {
            onChangeCompetitorsFleetTransfersSelectedDate(null);
        } else if (availableDates.length > 0) {
            onChangeCompetitorsFleetTransfersSelectedDate(availableDates[availableDates.length - 1]);
        }
    };

    return (
        <div>
            {/* Период */}
            <div className={styles.legHead}>{t`Период`}:</div>
            <StandardRadioGroup
                value={dateMode ? 'date' : 'range'}
                onChange={onChangePeriod}
            >
                <FormControlLabel
                    className={styles.isochroneFilterLabel}
                    control={
                        <Radio
                            checked={!dateMode}
                            value="range"
                            className={classnames(styles.isochroneFilterInput, {
                                [styles.checkedIsochroneFilterInput]: !dateMode,
                            })}
                            size="small"
                        />
                    }
                    label={t`Выбрать диапазон`}
                />
                <FormControlLabel
                    className={styles.isochroneFilterLabel}
                    control={
                        <Radio
                            checked={dateMode}
                            value="date"
                            className={classnames(styles.isochroneFilterInput, {
                                [styles.checkedIsochroneFilterInput]: dateMode,
                            })}
                            size="small"
                        />
                    }
                    label={t`Выбрать дату`}
                />
            </StandardRadioGroup>
            {dateMode && (
                <div style={{ paddingLeft: 5, paddingRight: 10, marginBottom: 10 }}>
                    <TextField
                        className="fleet-transfers-date-select"
                        select
                        SelectProps={{ native: true }}
                        value={selectedDate || ''}
                        onChange={e => onChangeCompetitorsFleetTransfersSelectedDate(e.target.value)}
                        variant="outlined"
                        size="small"
                        fullWidth
                    >
                        {availableDates.length === 0 ? (
                            <option value="">{t`Загрузка...`}</option>
                        ) : (
                            availableDates.map(d => (
                                <option
                                    key={d}
                                    value={d}
                                >{formatDate(d)}</option>
                            ))
                        )}
                    </TextField>
                </div>
            )}

            {/* Тип СИМ */}
            <div className={styles.legHead}>{t`Тип СИМ`}:</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', alignItems: 'center', paddingLeft: 10, paddingBottom: 10, columnGap: 12, rowGap: 4 }}>
                {vehicleTypes.map(({ value, label, stateKey }) => (
                    <Fragment key={value}>
                        <label htmlFor={`fleet-transfers-${value}`}>{label}</label>
                        <div style={{ justifySelf: 'end', padding: 5 }}>
                            <label className={styles.switch}>
                                <input
                                    type='checkbox'
                                    id={`fleet-transfers-${value}`}
                                    checked={mapFilters[stateKey]}
                                    onChange={() => onToggleVehicle(value)}
                                />
                                <span className={classnames(styles.sliderRound, styles.slider)} />
                            </label>
                        </div>
                    </Fragment>
                ))}
            </div>

            {/* Динамический фильтр операторов — переброски флота конкурентов */}
            <DynamicAttributeFilter
                title={t`Операторы (переброски)`}
                attributeTypes={functionalAreasYandexUrentTypes}
                availableValues={mapFilters.competitorsFleetTransfersAvailableOperators}
                disabledValues={mapFilters.competitorsFleetTransfersOperatorsDisabled}
                onToggle={onChangeCompetitorsFleetTransfersOperatorsFilter}
                inputNamePrefix="competitors-fleet-transfers-operator"
            />
        </div>
    );
};
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(
    mapStateToProps,
    {
        onChangeCompetitorsFleetTransfersDateMode,
        onChangeCompetitorsFleetTransfersOperatorsFilter,
        onChangeCompetitorsFleetTransfersSelectedDate,
        onChangeCompetitorsFleetTransfersShowScooters,
        onChangeCompetitorsFleetTransfersShowBicycles,
    }
)(FleetTransfersFilterComponent);

export const FleetTransfersFilter = withDisplayedLayersCheck(ConnectedComponent, 'Переброски флота (конкуренты)');
